export const initialWidget = {
    isFetchingFeaturedAgent: false,
    featuredAgentUrl: null,
    isFetchingFeaturedListing: false,
    featuredListingUrl: null,
    isFetchingSpotlightListing: false,
    spotlightListingUrl: null
};
